import React, { Component } from "react";

class BackPageImageContainer extends Component {
  render() {
    const { listgenUserID } = this.props.agentData;
    const { mlsAreaID } = this.props.currentArea;
    const backPagePhotoURL =
      this.props.backPagePhotoURL ||
      (this.props.currentArea && this.props.currentArea.backPagePhotoURL);
    let useDefault = true;

    if (backPagePhotoURL) {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src={backPagePhotoURL}
            className="auto-height-custom-backpage-img"
            alt="Custom Back Page"
          />
        </div>
      );
    }

    if (mlsAreaID === "MRN-A2300H") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/070226_LuciaA_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Lucia A Back Page July 2026"
          />
        </div>
      );
    } else if (mlsAreaID === "CCA-5601E") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/BackCover_070426_AlhambraValley-MuirWoods.jpg"
            className="auto-height-custom-backpage-img"
            alt="Dan Fitz Alhambra Valley July 2026 Second"
          />
        </div>
      );
    } else if (mlsAreaID === "CCA-5400F") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/BackCover_070426_GregoryGardens-Standwood.jpg"
            className="auto-height-custom-backpage-img"
            alt="Dan Fitz Gregory Gardens July 2026 Second"
          />
        </div>
      );
    } else if (mlsAreaID === "CCA-5100C") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/BackCover_070426_ReliezValley-Springhill.jpg"
            className="auto-height-custom-backpage-img"
            alt="Dan Fitz reliez valley July 2026 Second"
          />
        </div>
      );
    } else if (listgenUserID === "109973") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/070426_BackCover_jeffBruno.jpg"
            className="auto-height-custom-backpage-img"
            alt="Jeff Bruno Back Page July 2026 Second"
          />
        </div>
      );
    } else if (mlsAreaID === "SCL-17A") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/070226_TakamiHamadani_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Takami Hamadani Back Page July 2026"
          />
        </div>
      );
    } else if (mlsAreaID === "CCA-5200I") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/070326_KurtPiper_BackCover-3-Updated.jpg"
            className="auto-height-custom-backpage-img"
            alt="Moraga Kurt Piper Back Page July 2026"
          />
        </div>
      );
    } else if (listgenUserID === "104782") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/040826_LeslieLiang_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Leslie Liang Back Page April 2026"
          />
        </div>
      );
    } else if (listgenUserID === "109809") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/040826_LynnMolloy_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Lynn Molloy Back Page April 2026"
          />
        </div>
      );
    } else if (listgenUserID === "109818") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/040426_LeslieLomondBackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Leslie Lomond Back Page April 2026"
          />
        </div>
      );
    } else if (listgenUserID === "105047" || listgenUserID === "102286") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/040226_KaterynaDavydova_Back+Cover.png"
            className="auto-height-custom-backpage-img"
            alt="kateryna neighborhood 1 may"
          />
        </div>
      );
    } else if (listgenUserID === "105896") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/070326_MaryMurphy_backCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Mary Murphy Back Page July 2026"
          />
        </div>
      );
    } else if (mlsAreaID === "SNM-B1300P") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/063026_Sonoma_JohnThompson_BACK.jpg"
            className="auto-height-custom-backpage-img"
            alt="Mission Bay John Thompson Back Page July 2026"
          />
        </div>
      );
    } else if (mlsAreaID === "SLN-C2401A") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/063026_Eastridge_JohnThompson_BACK.jpg"
            className="auto-height-custom-backpage-img"
            alt="Eastridge John Thompson Back Page July 2026"
          />
        </div>
      );
    } else if (listgenUserID === "112368") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/030626_DebbieSouza_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Debbie Souza Back Page March 2026"
          />
        </div>
      );
    } else if (listgenUserID === "110294") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/040726_ChristieSattler_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Christie Sattler Back Page April 2026"
          />
        </div>
      );
    } else if (listgenUserID === "109696") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/030526_KevinMaria-LiangRosa_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Kevin Maria Liang Rosa Back Page March 2026"
          />
        </div>
      );
    } else if (listgenUserID === "107304") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/030326_COMPASS_seller-BackCover_1.jpg"
            className="auto-height-custom-backpage-img"
            alt="COMPASS seller Back Page March 2026"
          />
        </div>
      );
    } else if (listgenUserID === "110030") {
      return (
        <div className="centered-back-page-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/060526_DanielleCranston_BackCover_2.jpg"
            className="centered-height-custom-backpage-img"
            alt="Danielle Cranston Back Page June 2026  updated"
          />
        </div>
      );
    } else if (listgenUserID === "109901") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/070226_JessicaEvans_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Jessica Evans Back Page July 2026"
          />
        </div>
      );
    } else if (listgenUserID === "113592") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/050826_DanFitzpatrick_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Dan Fitzpatrick Back Page May 2026"
          />
        </div>
      );
    } else if (listgenUserID === "106531") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/011426_EmmaElfing_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Emma Elfing Back Page February 2026"
          />
        </div>
      );
    } else if (listgenUserID === "108197") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/070226_AlexMichas_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Alex Michas Back Page July 2026"
          />
        </div>
      );
    } else if (listgenUserID === "105805") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/011326_KatherineHunt_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Katherine Hunt Back Page January 2026"
          />
        </div>
      );
    } else if (listgenUserID === "109879") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/070226_KhushKermanizadeh_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Khush Back Page July 2026"
          />
        </div>
      );
    } else if (listgenUserID === "104835") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/011226_PattyDwyer_BackCover.png"
            className="auto-height-custom-backpage-img"
            alt="Patty Dwyer Back Page January 2026"
          />
        </div>
      );
    } else if (listgenUserID === "112358") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/011126_DianeSanderson_backCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Diane Sanderson Back Page January 2026"
          />
        </div>
      );
    } else if (listgenUserID === "109657") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/120925_BackCover_ChantelHenson_1.jpg"
            className="auto-height-custom-backpage-img"
            alt="Chantel Henson Back Page December 2026"
          />
        </div>
      );
    } else if (listgenUserID === "109705") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/060826_KurtPiper_BackCover-JPG.jpg"
            className="auto-height-custom-backpage-img"
            alt="Kurt Pipe Back Page July 2026"
          />
        </div>
      );
    } else if (listgenUserID === "101001") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/040726_AnnetteVait_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Annette Back Page April 2026 2"
          />
        </div>
      );
    } else if (
      listgenUserID === "100658" ||
      listgenUserID === "100652" ||
      listgenUserID === "100660" ||
      listgenUserID === "100474" ||
      listgenUserID === "100656"
    ) {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/C-H-RealEstateGrp.jpg"
            className="auto-height-custom-backpage-img"
            alt="Kelly Mahan Back Page November 2025"
          />
        </div>
      );
    } else if (listgenUserID === "100661") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/111025_KellyMahanHerrick_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Kelly Mahan Back Page November 2025"
          />
        </div>
      );
    } else if (listgenUserID === "112334") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://pma-coverphotos.s3.us-east-1.amazonaws.com/non-covers/063026_BackCover_JoujouChawla.jpg"
            className="auto-height-custom-backpage-img"
            alt="Joujou Chawla Back Page July 2026"
          />
        </div>
      );
    } else if (listgenUserID === "100462") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/060426_Back+Cover_KristinArntz.jpg"
            className="auto-height-custom-backpage-img"
            alt="Kristin Arntz Back Page June"
          />
        </div>
      );
    } else if (listgenUserID === "106991") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/090825_JohnSaddi_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Crestmoor Park"
          />
        </div>
      );
    } else if (mlsAreaID === "ALA-3900K") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/081925_ChrisDuarte_IceCreamSummer.jpg"
            className="auto-height-custom-backpage-img"
            alt="Del Prado August 2025"
          />
        </div>
      );
    } else if (mlsAreaID === "ALA-3900AD") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/070226_Flashberger_BackCover-(1).jpg"
            className="auto-height-custom-backpage-img"
            alt="Val Vista July 2026"
          />
        </div>
      );
    } else if (mlsAreaID === "ALA-3900AK") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/070226_Flashberger_BackCover-(1).jpg"
            className="auto-height-custom-backpage-img"
            alt="East Vineyard Plus July 2026"
          />
        </div>
      );
    } else if (listgenUserID === "102843") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/120325_BackCover_GALLI-team-(1).jpg"
            className="auto-height-custom-backpage-img"
            alt="Galli back page December 2025"
          />
        </div>
      );
    } else if (listgenUserID === "107254") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/011526_GigiSrour_Back.jpg"
            className="auto-height-custom-backpage-img"
            alt="Gigi Srour January 2026"
          />
        </div>
      );
    } else if (listgenUserID === "106999") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/082025_ShantiMinkstein_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Shanti Mintz Back Page August 2025"
          />
        </div>
      );
    } else if (listgenUserID === "109938") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/070426_BackCover_AlysonGrant.jpg"
            className="auto-height-custom-backpage-img"
            alt="Alyson GrantBack Page July 2026 Second"
          />
        </div>
      );
    } else if (mlsAreaID === "CCA-4500K") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/071625_JeffBruno-AlysonGrant_OnePhoto_new.jpg"
            className="auto-height-custom-backpage-img"
            alt="Greater Sycamore Back Page"
          />
        </div>
      );
    } else if (mlsAreaID === "CCA-4500N") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/071625_JeffBruno-AlysonGrant_TwoPhotos_new.jpg"
            className="auto-height-custom-backpage-img"
            alt="Shadow Hills Danville Crest Back Page"
          />
        </div>
      );
    } else if (listgenUserID === "107037") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/040226_KevinBarranti_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Kevin Barranti Back Page April"
          />
        </div>
      );
    } else if (listgenUserID === "106475") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/120925_JohnSayage_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="John Sayage Back Page December 2025"
          />
        </div>
      );
    } else if (listgenUserID === "107557") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/070127_NicoleEasterday_backCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Nicole EasterdayBack Page July 2026"
          />
        </div>
      );
    } else if (mlsAreaID === "xSMA-437") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/julie-flouty-sm-baywood-backpage-october.jpg"
            className="auto-height-custom-backpage-img"
            alt="Julie Flouty Back Page San Mateo"
          />
        </div>
      );
    } else if (listgenUserID === "106421") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/060226_JulieFlouty_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Julie Flouty Back Page June"
          />
        </div>
      );
    } else if (listgenUserID === "107270") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/051925_edit_MarkKotch-MovieNightAd.jpg"
            className="auto-height-custom-backpage-img"
            alt="Mark Kotch Backpage"
          />
        </div>
      );
    } else if (listgenUserID === "105918") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/042125_BackCover__GaryBulanti.jpg"
            className="auto-height-custom-backpage-img"
            alt="Gary Bulanti Invite"
          />
        </div>
      );
    } else if (listgenUserID === "x102843") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/GalliTeamCUSTOM_BackCover_300ppi.jpg"
            className="auto-height-custom-backpage-img"
            alt="Return on Investment Infographic"
          />
        </div>
      );
    } else if (listgenUserID === "105915") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/032025_MAR-25_KittyTranggana_BackCover_3.jpg"
            className="auto-height-custom-backpage-img"
            alt="Kitty Backpage"
          />
        </div>
      );
    } else if (listgenUserID === "105795") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/050826_GregCelotti_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Greg Celotti Back Page May 2026"
          />
        </div>
      );
    } else if (listgenUserID === "102413") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/031825_BkCvr_3-PhaseMarktg_DaphneChou_150ppi.jpg"
            className="auto-height-custom-backpage-img"
            alt="Daphne Chou backpage"
          />
        </div>
      );
    } else if (listgenUserID === "102286" || listgenUserID === "105047") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/031725_katerynaDavydova_BackCover_2.jpg"
            className="auto-height-custom-backpage-img"
            alt="kateryna-september-img"
          />
        </div>
      );
    } else if (listgenUserID === "105224") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/070126_JayChodagam_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Jay Chodagam Back Page July 2026"
          />
        </div>
      );
    } else if (listgenUserID === "104874") {
      //comment
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/040826_RosaBaltodano_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Rosa Baltodano Back Page"
          />
        </div>
      );
    } else if (listgenUserID === "100030") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/031225_NateRandall_BackCover.jpg"
            className="auto-height-custom-backpage-img"
            alt="Nate Randall ROI"
          />
        </div>
      );
    } else if (useDefault) {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/032125_PropImprv_BackCover-300ppi.jpg"
            className="auto-height-custom-backpage-img"
            alt="Return on Investment Infographic"
          />
        </div>
      );
    } else if (listgenUserID === "106550") {
      return (
        <div className="auto-height-custom-backpage-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/Oct2024-ListGenBackCover_Christina+Ng_edit.jpg"
            className="auto-height-custom-backpage-img"
            alt="kateryna-september-img"
          />
        </div>
      );
    } else {
      return <div className="auto-height-custom-backpage-container"></div>;
    }
  }
}

export default BackPageImageContainer;
